<template>
    <section id="section-home">
        <GridWarp :class="['grid-warp-outer', (step>=totalSteps) ? 'full' : '']"/>
        <div class="progressbar" :style="progressProgressBar">
            <div class="line" :style="progressLine"></div>
            <div class="indicator" :style="progressDot">
                <span></span>
            </div>
            <div class="bottom" :style="progressStatus">{{ progressStatusLabel }}</div>
        </div>
        <div
            @click="setIsOverInitiated(!this.isOverInitiated)"
            @mouseenter="setIsOverInitiated(true)"
            @mouseleave="setIsOverInitiated(false)"
            :class="['tr', (isOverInitiated) ? 'over' : '']"
        >
            <div class="txt">
                <span class="off">initiated</span>
                <span class="on">by <a href="https://www.instagram.com/prforartists/" target="_blank">@prforartists</a>  & <a
                    href="https://www.instagram.com/heroicartcodex/" target="_blank">@heroicartcodex</a></span>
            </div>
        </div>
        <div
            @click="setIsOverConnections(!this.isOverConnections)"
            @mouseenter="setIsOverConnections(true)"
            @mouseleave="setIsOverConnections(false)"
            :class="['bl', (isOverConnections) ? 'over' : '']"
        >
            <div class="txt">
                <span class="off">{{ connectionsText }}</span>
                <span class="on">from the minds who brought you</span>
            </div>
        </div>
        <div
            :class="['br', (isOverCounter) ? 'over' : '']"
            @click="setIsOverCounter(!this.isOverCounter)"
            @mouseenter="setIsOverCounter(true)"
            @mouseleave="setIsOverCounter(false)"
        >
            <div class="counter">
                <span class="off">{{ counter }}</span>
                <span class="on">subject id #</span>
            </div>
        </div>
        <div class="enter">
            <div class="flx2">
                <div class="steps">
                    <h1>the
                        <div class="prah-hover"><span class="off">prah</span><span class="on"><img
                            src="@/assets/images/global/tt.svg"></span></div>
                        list
                    </h1>
                    <div v-show="step===1" class="step">
                        <div class="dot-align">
                            <div @click="gotoStep(2)" class="dot big"></div>
                        </div>
                    </div>
                    <div v-show="step===2" class="step">
                        <h3>how will you appear</h3>
                        <div class="choices">
                            <div @click="setDefinition('creator')" class="choice">
                                <div class="choicedot"></div>
                                <div class="txt">as a creator</div>
                            </div>
                            <div @click="setDefinition('seeking')" class="choice">
                                <div class="choicedot"></div>
                                <div class="txt">as a patron</div>
                            </div>
                        </div>
                    </div>
                    <div v-show="step===3" class="step">
                        <h3>{{ howDoYou }}</h3>
                        <div class="choices">
                            <div class="field">
                                <div class="i">
                                    <textarea @input="checkHowDoYou" rows="7" ref="howDoYou" name="howDoYou"
                                              placeholder="briefly"/>
                                </div>
                            </div>
                            <div v-if="howDoYouPass" class="dot-align">
                                <div @click="gotoStep(4)" class="dot"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="step===4" class="step">
                        <h3>now or not</h3>
                        <div class="choices">
                            <div class="field">
                                <div class="i">
                                    <input
                                        @change="checkEmailAndName"
                                        ref="fullName" type="name" name="fullName"
                                        placeholder="Your Name"
                                    />
                                </div>
                            </div>
                            <div class="field">
                                <div class="i">
                                    <input @change="checkEmailAndName" ref="email" type="email" name="email"
                                           placeholder="Your Email"
                                    />
                                </div>
                            </div>
                            <div v-if="emailAndNamePass" class="dot-align">
                                <div @click="gotoStep(5)" class="dot"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="step===5" class="step">
                        <h3>handles handler</h3>
                        <div class="choices">
                            <div class="field">
                                <div class="i">
                                    <input ref="website" type="text" name="website" placeholder="website"/>
                                </div>
                            </div>
                            <div class="field">
                                <div class="i">
                                    <input ref="instagram" type="text" name="instagram" placeholder="instagram"/>
                                </div>
                            </div>
                            <div class="field">
                                <div class="i">
                                    <input ref="twitterx" type="text" name="twitter" placeholder="twitterx"/>
                                </div>
                            </div>
                            <div class="field">
                                <div class="i">
                                    <input ref="tiktok" type="text" name="tiktok" placeholder="tiktok"/>
                                </div>
                            </div>
                            <div class="field">
                                <div class="i">
                                    <input ref="youtube" type="text" name="youtube" placeholder="youtube"/>
                                </div>
                            </div>
                            <div class="dot-align">
                                <div @click="gotoStep(6)" class="dot"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="step===6" class="step">
                        <h3>manifestor</h3>
                        <div class="choices">
                            <div class="field">
                                <div class="i">
                                    <textarea rows="7" ref="notes" name="notes"
                                              placeholder="what is your guiding vision"/>
                                </div>
                            </div>
                            <div class="dot-align">
                                <div @click="gotoStep(7)" class="dot"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="step===7" class="step step4">
                        <h3>the "end"</h3>
                        <p>phase 2 is coming</p>
                        <p>share for maximum nexus</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import gh from "@/helpers/gh"
import axios from 'axios';
import {v4 as uuidv4} from 'uuid';
import GridWarp from "@/components/blocks/GridWarp.vue";


export default {
    name: "HomePage",
    components: {
        GridWarp
        //YouTubeComponent
    },
    data() {
        return {
            localStorage: localStorage,
            gh: gh,
            window: window,
            document: document,
            json: null,

            userId: localStorage.getItem('userId') || uuidv4(),

            counterInterval: null,
            counter: null,
            step: 1,
            definition: null,
            connectionsText: null,
            howDoYouPass: false,
            emailAndNamePass: false,
            endBeginning: '',

            isOverInitiated: false,
            isOverCounter: false,
            isOverConnections: false,

            pulseInterval: null,

            totalSteps: 7,

        }
    },
    mounted() {
        ['fullName', 'email', 'website', 'instagram', 'twitterx', 'tiktok', 'youtube', 'notes', 'howDoYou'].forEach(ref => {
            if (this.$refs[ref]) {
                this.$refs[ref].value = localStorage.getItem(ref)
            }
        });

        setTimeout(() => {
            this.checkEmailAndName()
            this.checkHowDoYou()
        }, 100)


        // counters
        this.startCounter()
        this.setConnectionsText()
        this.pulseScaleIncrement()
    },
    computed: {
        progressProgressBar() {
            let ret = 'opacity:0'
            if (this.step > 1) {
                ret = 'opacity:1'
            }
            return ret
        },
        progressLine() {
            let ret = 'height:0'
            if (this.step > 1) {
                ret = 'height:100%'
            }
            return ret
        },
        progressDot() {
            let adjStep = this.step - 2
            let adjTot = this.totalSteps - 2
            let pct = 100 * (adjStep / adjTot)
            //let ret = `transform: translateY(${pct}%);`
            let ret = null
            if (adjStep < 0) {
                pct = 0
                ret = `top: ${pct}%;width:0px;`
            } else {
                ret = `top: ${pct}%;width:11px;`
            }
            return ret
        },

        progressStatus() {
            let ret = 'opacity:0;'
            if (this.step > 1) {
                ret = 'opacity:1;'
            }
            if (this.step >= this.totalSteps) {
                ret += 'font-size:30px;bottom:-7px;'
            }
            return ret
        },
        progressStatusLabel() {
            let ret = (this.step - 1) + '/' + (this.totalSteps - 1)
            if (this.step >= this.totalSteps) {
                ret = '➳'
            }
            return ret
        },
        howDoYou() {
            let ret
            if (this.definition === 'seeking') {
                ret = 'what is your business?'
            } else {
                ret = 'what do you create?'
            }
            return ret
        },
    },
    methods: {
        pulseScaleIncrement() {
            let scale = 2.2;
            const increment = 0.1;

            this.pulseInterval = setInterval(() => {
                scale += increment;
                document.documentElement.style.setProperty('--pulse-scale', scale);

                if (scale > 5) {
                    clearInterval(this.pulseInterval)
                }
            }, 2500); // matches your animation duration
        },
        setIsOverInitiated(val) {
            this.isOverInitiated = val
        },
        setIsOverCounter(val) {
            this.isOverCounter = val
        },
        setIsOverConnections(val) {
            this.isOverConnections = val
        },
        submitStepData() {
            ['fullName', 'email', 'website', 'instagram', 'twitterx', 'tiktok', 'youtube', 'notes', 'howDoYou'].forEach(ref => {
                if (this.$refs[ref]) {
                    localStorage.setItem(ref, this.$refs[ref].value);
                }
            });
            localStorage.setItem('definition', this.definition);
            localStorage.setItem('userId', this.userId);

            const formData = new FormData();

            formData.append('userId', this.userId);
            formData.append('step', this.step);
            formData.append('definition', this.definition);
            formData.append('fullName', this.$refs.fullName?.value || '');
            formData.append('email', this.$refs.email?.value || '');
            formData.append('website', this.$refs.website?.value || '');
            formData.append('instagram', this.$refs.instagram?.value || '');
            formData.append('twitterx', this.$refs.twitterx?.value || '');
            formData.append('tiktok', this.$refs.tiktok?.value || '');
            formData.append('youtube', this.$refs.youtube?.value || '');
            formData.append('notes', this.$refs.notes?.value || '');
            formData.append('howDoYou', this.$refs.howDoYou?.value || '');

            axios.post(`${process.env.VUE_APP_API}`, formData)
                .catch(error => console.error(error));
        },
        setEndBeginngingText() {
            const library = [
                "end",
                "beginning"
            ];
            let libraryInc = 0
            setInterval(() => {
                libraryInc++
                if (libraryInc >= library.length) {
                    libraryInc = 0
                }
                this.endBeginning = library[libraryInc]
            }, 1000);
        },
        setConnectionsText() {
            const library = [
                "the nexus",
                //"from the minds who brought you",
                //"now or not",
                //"enter the unknown",
                //"closer",
                //"enter or regret",
                //"beyond the line",
            ];
            const defaultTxt = 'phase 1'
            setInterval(() => {
                const rnd = Math.floor(Math.random() * 10)
                if (rnd === 0) {
                    const rnd2 = Math.floor(Math.random() * library.length)
                    this.connectionsText = library[rnd2]
                } else {
                    this.connectionsText = defaultTxt
                }
            }, 1000);
            this.connectionsText = defaultTxt
        },
        startCounter() {
            // const monthNames = [
            //     "January", "February", "March", "April", "May", "June",
            //     "July", "August", "September", "October", "November", "December"
            // ];
            // Pacific Time is UTC-7 in May (PDT)
            const startTime = new Date('2025-05-31T12:00:00-07:00').getTime();
            //const endTime = new Date('2025-06-30T12:00:00-07:00').getTime();
            this.counterInterval = setInterval(() => {
                //const date = new Date();
                const now = Date.now()
                //const currentMonth = monthNames[date.getMonth()]
                //this.counter = now + ' ' + (now - startTime)
                this.counter = now - startTime
                //this.counter = endTime - now
            }, 21);
        },
        gotoStep(val) {
            if (val === this.totalSteps) {
                this.gh.playHaptic2()
                this.gh.playGoldenYears()

            } else {
                this.gh.playHaptic()
            }
            this.step = val
            this.submitStepData()
        },
        setDefinition(val) {
            this.definition = val
            this.gotoStep(3)
        },
        checkHowDoYou() {
            const howDoYou = this.$refs.howDoYou.value.trim();
            if (howDoYou.length < 3) {
                this.howDoYouPass = false
                return
            }
            this.howDoYouPass = true
        },
        checkEmailAndName() {
            const fullName = this.$refs.fullName.value.trim();
            const email = this.$refs.email.value.trim();

            if (fullName.length < 2) {
                this.emailAndNamePass = false
                return
            }
            if (!this.isValidEmail(email)) {
                this.emailAndNamePass = false
                return
            }
            this.emailAndNamePass = true
        },
        isValidEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return regex.test(email)
        }
    }
}
</script>